import { render } from "./AuthenticatedPDFViewer.vue?vue&type=template&id=4070a79f"
import script from "./AuthenticatedPDFViewer.vue?vue&type=script&lang=js"
export * from "./AuthenticatedPDFViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__